// src/style-comps/AdminDashboard.styles.js
import styled from 'styled-components';

// Container 本身不再自己捲動；改成 flex column，把捲動範圍縮小到 ContentWrapper/
// TableWrapper（見下方），這樣 Filter 區跟 Pagination 永遠固定在畫面上，只有中間
// 的表格內容會上下滑動，Table Header 也才能正確 sticky（否則 TableWrapper 的
// overflow-x:auto 會變成離 TableHead 最近的捲動容器，害 sticky 完全失效）。
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 28px;
  width: 100%;
  height: 100%;
  font-family: "Roboto", sans-serif;
  color: #333;
  box-sizing: border-box;
`;

export const ControlBar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
  flex-shrink: 0;
`;

// Filter 區固定在頂部：因為 Container 已經是 flex column 且不再自己捲動，
// 這裡不需要 position:sticky，維持一般排版即可永遠可見。
export const StickyFilterBar = styled.div`
  flex-shrink: 0;
`;

export const HostifyInput = styled.input`
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 14px;
  width: 160px;
  &:focus {
    border-color: #61cbc9;
    outline: none;
    box-shadow: 0 0 4px rgba(97, 203, 201, 0.4);
  }
`;

export const SyncHostifyButton = styled.button`
  background-color: #61cbc9;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 14px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: background-color 0.2s;
  &:hover {
    background-color: rgba(97,203,201,0.9);
  }
`;

// 真正負責上下/左右捲動的容器：flex:1 + min-height:0 讓它吃滿 Container 剩下的
// 高度並在內部自己捲動，TableHead 的 position:sticky 就是相對「這一層」在固定。
export const TableWrapper = styled.div`
  width: 100%;
  min-height: 0;
  flex: 1;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  overflow: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
`;

export const TableHead = styled.thead`
  position: sticky;
  top: 0;
  background-color: #f9fafb;
  border-bottom: 2px solid #eaeaea;
  z-index: 2; 
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
`;

export const TableRow = styled.tr`
  font-size: 14px;
  transition: background 0.2s, box-shadow 0.2s;
  &:hover {
    background-color: #f7fdfc;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.05);
  }
`;

export const TableHeader = styled.th`
  padding: 14px 16px;
  text-align: left;
  font-weight: 600;
  color: #444;
  white-space: nowrap;
  border-bottom: 2px solid #eaeaea;
`;

export const TableBody = styled.tbody``;

export const TableData = styled.td`
  padding: 14px 16px;
  border-bottom: 1px solid #f1f1f1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
`;

// 把 Container 分配到的剩餘高度往下傳給 TableWrapper，讓它能真的自己捲動。
export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

export const EditButton = styled.div`
  background-color: #61cbc9;
  color: #ffffff;
  padding: 4px 12px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  transition: all 0.2s ease-in-out;
  &:hover {
    background-color: rgba(97,203,201,0.9);
    transform: scale(1.03);
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 6px;
  margin-top: 20px;
  flex-wrap: wrap;
  gap: 10px;
  flex-shrink: 0;
`;




export const PageButton = styled.button`
  padding: 6px 12px;
  border-radius: 6px;
  background: ${({ active }) => (active ? '#61cbc9' : 'transparent')};
  border: 1px solid ${({ active }) => (active ? '#61cbc9' : '#ccc')};
  color: ${({ active }) => (active ? '#fff' : '#333')};
  cursor: pointer;
  min-width: 36px;
  font-size: 14px;
  transition: all 0.2s ease;
  &:hover {
    background-color: rgba(97,203,201,0.15);
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const RowsSelect = styled.select`
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 14px;
  background-color: white;
  color: #333;
  appearance: auto;       
  cursor: pointer;
  transition: all 0.2s;
  &:hover { border-color: #61cbc9; }
`;

export const PageSelect = styled.select`
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 14px;
  background-color: white;
  color: #333;
  appearance: auto;
  cursor: pointer;
  transition: all 0.2s;
  &:hover { border-color: #61cbc9; }
`;


export const SearchInput = styled.input`
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid #ccc;
  width: 260px;
  font-size: 14px;
  transition: all 0.2s ease-in-out;
  &:focus {
    border-color: #61cbc9;
    outline: none;
    box-shadow: 0 0 4px rgba(97, 203, 201, 0.4);
  }
`;

export const FilterLabel = styled.label`
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  user-select: none;
  cursor: pointer;
  color: #333;
  font-weight: 500;
  letter-spacing: 0.3px;

  input[type="checkbox"] {
    appearance: none;             /*  自訂 checkbox */
    width: 16px;
    height: 16px;
    border: 2px solid #61cbc9;    /*  外框顏色 */
    border-radius: 4px;
    display: inline-block;
    position: relative;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  input[type="checkbox"]:checked {
    background-color: #61cbc9;
    border-color: #61cbc9;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M20 6 9 17l-5-5'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 11px 11px;
  }

`;


// ===== 表格勾選框：圓角 + teal 主題的自訂樣式 =====
export const TableCheckbox = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  width: 17px;
  height: 17px;
  border: 1.5px solid #c9c9c9;
  border-radius: 5px;
  background: #fff;
  cursor: pointer;
  position: relative;
  vertical-align: middle;
  transition: all 0.15s ease;
  &:hover {
    border-color: #61cbc9;
  }
  &:checked {
    background-color: #61cbc9;
    border-color: #61cbc9;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M20 6 9 17l-5-5'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 12px 12px;
  }
`;

// ===== 搜尋框（含放大鏡 icon 定位） =====
export const SearchWrap = styled.div`
  position: relative;
  flex: 1;
  min-width: 200px;
  max-width: 300px;
  svg {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }
  input {
    width: 100%;
    padding-left: 36px;
    box-sizing: border-box;
  }
`;

// ===== Sync 工具：輸入框 + 按鈕合體成單一控件 =====
export const SyncGroup = styled.div`
  display: flex;
  align-items: stretch;
  input {
    border-radius: 8px 0 0 8px;
    border-right: none;
    width: 110px;
  }
  button {
    border-radius: 0 8px 8px 0;
  }
`;

export const SyncWrap = styled.div`
  position: fixed;
  bottom: 30px;
  right: 30px;
  display: flex;
  gap: 12px;
  z-index: 10;
`;

export const SyncButton = styled.button`
  padding: 12px 20px;
  border-radius: 30px;
  background-color: #ff6600;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 8px;
  &:hover {
    background-color: rgba(255, 102, 0, 0.8);
  }
  img {
    width: 16px;
    height: 16px;
    transition: transform 0.2s ease;
  }
  &:hover img {
    transform: rotate(-20deg);
  }
`;

export const ErrorPopup = styled.div`
  position: fixed;
  top: 70px;
  right: -600px;
  transform: translateY(0%);
  background-color: rgba(97, 203, 201, 0.4);
  color: #333;
  padding: 12px 20px;
  border-radius: 8px;
  width: 80%;
  max-width: 400px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: right 0.5s ease-in-out;
  ${({ show }) => show && `right: 10px;`}
`;

export const CloseButton = styled.button`
  background-color: transparent;
  color: #333;
  border: none;
  font-size: 24px;
  cursor: pointer;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  font-weight: bold;
  &:hover {
    color: #61cbc9;
  }
`;
export const RolePill = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  background-color: #61cbc9;
  margin: 2px 3px 2px 0;
  white-space: nowrap;
`;
